import React from 'react'
import { Dimmer, Grid, Loader, Statistic } from 'semantic-ui-react';
import './channelgradients.css'
import { numberWithCommas, formatNumber } from '../Common/NumberWithComas';
import _ from 'lodash'
import axios from 'axios'
import { BlueMoon, handleError } from '../BlueMoon';
import { Helmet } from 'react-helmet'
import { isMobile } from 'react-device-detect';
import { getTheme } from '../../config/clientConfig'

// Card title from the data's channel name: acronyms stay upper-case, the rest is title-cased
// ('TV', 'OOH', 'In Venue', 'Social').
const ACRONYMS = ['TV', 'OOH'];
const channelLabel = (name) => {
    const upper = name.toUpperCase();
    return ACRONYMS.includes(upper) ? upper : _.startCase(_.lowerCase(name));
};

class ChannelGradientCards extends React.Component {
    constructor(props) {
        super(props);
        this.theme = getTheme();
        this.state = { data: [], dimmer: true };
    }

    // Get gradient style for a channel from theme
    getChannelGradient = (channelName) => {
        const channelKey = channelName.toLowerCase().replace(' ', '');
        const channel = this.theme.channels[channelKey];
        if (channel && channel.gradient) {
            return {
                backgroundImage: `linear-gradient(to right, ${channel.gradient[0]}, ${channel.gradient[1]})`
            };
        }
        // Fallback to sponsorship gradient for unknown channels
        return {
            backgroundImage: `linear-gradient(to right, ${this.theme.channels.sponsorship.gradient[0]}, ${this.theme.channels.sponsorship.gradient[1]})`
        };
    }


    getTotal = (data) => {
        return _.round(data.reduce((prev, curr) => {
            
            return _.toNumber(curr['value']) + prev;
        }, 0));
    }

    calculatePercent = (data) => {
        var total = this.state.total;
        console.log(total, "value")
        return data.map((row) => {
            row['percent'] = _.round(_.toInteger(row['value']) / total, 2);
            row['impressions'] = _.toInteger(row['impressions']);
            // console.log(row['percent']);
            return row;
        })
    }

    componentDidUpdate =  (prevProps, prevState) =>{
        if(!_.isEqual(prevProps.params, this.props.params)){
            console.log("chabged");
            this.fetchData();
        }
    }

    fetchData = () =>{
        this.setState({dimmer: true}, () =>{
            axios.get(`${BlueMoon.ip}dashboard/channelContrib/`, {
                params: this.props.params
            }).then((response) => {
                this.setState({
                    total: this.getTotal(response.data.channelContrib)
                }, () => {
                    this.setState({
                        data: this.calculatePercent(response.data.channelContrib),
                        dimmer: false
                    })
                })
            }).catch((err)=>{
                handleError(err);
            });
        })
        
    }    

    componentDidMount = () => {
        axios.defaults.headers.common = {'Authorization': `Bearer ${localStorage.getItem('token')}`}
        this.fetchData();
    }


    createCard = (value, impressions, channelPercent, channelName, cards = 3) => {
        const gradientStyle = this.getChannelGradient(channelName === "sponsorship value" ? "sponsorship" : channelName);

        const textColor = this.theme.gradientCardText || 'black';
        return (<Grid style={{ ...gradientStyle, marginLeft: '0.1rem', borderRadius: '12px', color: textColor, marginTop: '0.1rem', height: '12vh'}}>
            <Grid.Row>
                <Grid.Column width={(channelName === "sponsorship value") ? 16 : 11} style={{ fontWeight: '900', fontFamily: 'sans-serif', fontSize:(isMobile)?"1em": _.round(window.innerWidth/5/2/100, 2)+"em" }}>{(channelName === "sponsorship value")? "Sponsorship Value": channelLabel(channelName)}</Grid.Column>
                {(channelName !== "sponsorship value") ? <Grid.Column width={5}   style={{padding: '0 1rem 0 0', textAlign: 'right', fontWeight: '700', fontSize: (isMobile)? "1em": _.round(window.innerWidth/cards/1.7/100, 2)+"em"}}>{_.round(channelPercent, 2)+"%"}</Grid.Column> : null}
            </Grid.Row>

            <Grid.Row>
                <Grid.Column width={16} style = {{position: 'absolute', bottom: '4px'}}>
                    <Statistic style={{width: "100%"}}>
                    {!this.state.dimmer &&
                    <div style={{display: "flex", flexDirection: "column", lineHeight: 1.1}}>
                    <Statistic.Value style={{ color: textColor }}>${numberWithCommas(_.round(value))}</Statistic.Value>
                    <span style={{ color: textColor, fontFamily: 'sans-serif', fontSize: (isMobile)?"0.8em":_.round(window.innerWidth/cards/2.8/100, 2)+"em", opacity: 0.85 }}>{formatNumber(impressions)} Impressions</span>
                    </div>
                    }
                    
                    {this.state.dimmer && <Dimmer style={{padding: 0, margin:0, background: 'none', height: "4px", }} active={true}> <Loader style={{left: "3rem"}} /> </Dimmer>}
                </Statistic>
                </Grid.Column>
            </Grid.Row>
        </Grid>);
    }

    render() {
        if (_.isEmpty(this.state.data)) return null;
        // font sizes were tuned for 3 cards (innerWidth/3/...); scale by the real card count so extra channels fit
        const cards = Math.max(3, this.state.data.length + 1);
        
        return (
            <Grid style={{ paddingRight: '1rem', width: "100%", boxSizing: 'border-box' }}  stackable>
                <Helmet>

                    <style type="text/css">{`
.ui.statistic .value, .ui.statistics .statistic>.value {
    font-size: ${(isMobile)?"1em":_.round(window.innerWidth/cards/1.4/100, 2)+"em"} !important;
}    

`}</style>
                </Helmet>
                <Grid.Row id="gradientsrow" columns={this.state.data.length + 1} style={{width: "100vw !important"}} >
                    <Grid.Column > {this.createCard(this.state.total, _.sumBy(this.state.data, "impressions"), 100,  "sponsorship value", cards)}
                    </Grid.Column>
                    {/* <Grid.Column > {this.createCard(this.state.total, 100, "In Venue")}</Grid.Column> */}

                    {
                        _.map(this.state.data, (channel) => {
                            // console.log(channel.percent)
                            return (
                                <Grid.Column > {this.createCard(channel.value, channel.impressions, channel.percent * 100, _.lowerCase(channel.name), cards)}
                                </Grid.Column>

                            )
                        })
                    }

                </Grid.Row>
            </Grid>)
    }
}

export default ChannelGradientCards;